import { Div } from '../../../base/components/native/div'
import { CENTER } from '../../../base/helpers/style'
import { shortUUID } from '../../../base/utils/id-generator'
import { IProduct, IProductVariant } from '../../../interfaces/product'
import db from '../../../services/db'
import { Colors } from './colors'
import { ProductCanvas } from './product-canvas'
import { ProductName } from './product-name'
import { ProductPrice } from './product-price'
import { Sizes } from './sizes'
import { SnipcartButton } from './snipcart-button'
import { StarIcon } from './start-icon'

export const Product = (product: IProduct) => {

    const { variants, name, snipCartCustomName } = product

    const base = Div()
    const selectedOption = variants.find((v) => v.isDefault) || variants[0]
    const canvas = ProductCanvas({ ...product, ...selectedOption } as any)
    const colors = Colors(variants)
    const sizes = Sizes(variants)
    const addToCart = SnipcartButton({ ...product, ...selectedOption } as any)
    const nameDiv = ProductName(name)
    const priceDiv = ProductPrice()
    base.append(canvas, nameDiv, priceDiv)
    if (snipCartCustomName === 'color') base.append(colors)
    if (snipCartCustomName === 'size') base.append(sizes)
    base.append(addToCart)
    db.find('favourites').then((favourites) => {
        const possible = favourites.find((f) => f.product_id === product.id)
        let isFavorite = 0
        if (possible) {
            isFavorite = possible.isDeleted === 0 ? 1 : 0
        }
        const star = StarIcon(isFavorite)
        base.append(star)
        star.on('change', (status: 0 | 1) => {
            if (possible) {
                db.update('favourites', possible.id, { ...possible,  isDeleted: status === 0 ? 1 : 0 })
            } else {
                db.save('favourites', { id: shortUUID(), product_id: product.id, isDeleted: status === 0 ? 1 : 0, isSynced: 0, at: new Date().toISOString() })
            }
        })
    })
    addToCart.disable()
    canvas.on('render', addToCart.updateAttributes, addToCart.enable, priceDiv.update)
    colors.on('select', canvas.render)
    sizes.on('select', canvas.render)

    base.cssClass({
        backgroundColor: 'white',
        paddingBottom: '20px',
        borderRadius: '10px',
        // border: '1px solid #ddd',
        margin: '30px auto 40px',
        flexDirection: 'column',
        ...CENTER,
    })

    return Object.assign(base, {
        // fill
    })
}